<div class="statistics-modal">
	<h2>Paramétrage des statistiques :</h2>

	Quand un article ci-dessous est activé, il sera visible dans l'onglet "linge d'hébergement" des statistiques.

	<div class="list-statistics">
		<mat-selection-list class="list-col" (selectionChange)="selectionChange($event)">
			<mat-list-option [selected]="article.enabled_statistics" *ngFor="let article of data"
				[checkboxPosition]="before" [value]="article.id">
				{{article.article.designation}}
			</mat-list-option>
		</mat-selection-list>
	</div>

	<div mat-dialog-actions class="dialog-buttons">
		<button mat-stroked-button (click)="refuse()">Annuler</button>
		<button mat-flat-button color="primary" (click)="onSubmit()">Enregistrer</button>
	</div>
</div>